/* eslint-disable import/no-cycle */
import { RefObject } from 'react';
import { Preference } from '../types/accordian.types';
import { PREFERENCE_OPTION1 } from './constant';

export const allEqual = (arr: any[]) =>
  arr.every((val) => val === arr[0] && val !== false);

export function checkPaperlessCondition(preference: Preference) {
  const array: boolean[] = [];
  Object.entries(preference).forEach((key) => {
    if (key[0] !== 'healthCoach') {
      if (key[1] === PREFERENCE_OPTION1) {
        array.push(true);
      } else {
        array.push(false);
      }
    }
  });
  return array.length > 0 ? allEqual(array) : false;
}

export function isValidatePhoneLength(val: string) {
  return val?.length >= 1 && val?.length < 14;
}

export function isNumberOnly(val: string) {
  return val.replace(/[^0-9]+/gi, '');
}

export function isValidateCodeLength(val: string) {
  return val?.length >= 1 && val?.length < 8;
}
export function formatPhoneNumber(value: string) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

export function formatConfirmationCode(value: string) {
  if (!value) return value;
  const confirmationCode = value.replace(/[^\d]/g, '');
  return confirmationCode;
}

export function isEmpty(value: string) {
  return (
    value === null ||
    value === undefined ||
    value === ' ' ||
    value?.length === 0
  );
}

export function isValidateEmail(value: string) {
  const re = /\S+@\S+\.\S+/;
  return re.test(value);
}

export function getRefValue<C>(ref: RefObject<C>) {
  return ref.current as C;
}

export function getLoginBrowser() {
  let result = '';
  if (
    (navigator.userAgent.indexOf('Opera') ||
      navigator.userAgent.indexOf('OPR')) !== -1
  ) {
    result = 'Opera';
  } else if (navigator.userAgent.indexOf('Edg') !== -1) {
    result = 'Edge';
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    result = 'Chrome';
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    result = 'Safari';
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    result = 'Firefox';
  } else if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    !!document.DOCUMENT_NODE === true
  ) {
    result = 'IE';
  } else {
    result = 'unknown';
  }
  return result;
}
